import React from 'react'
import SurgicalSchedulingContextWrapper from 'presentation/hospital/layouts/Home/SchedulingSector/context'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import HospitalCancelledScheduleSurgeryRequestsLayout from 'presentation/hospital/layouts/Home/SchedulingSector/CancelledScheduleSurgeryRequests'

const HospitalCancelledScheduledSurgeryRequests = () => {
  return (
    <SurgicalSchedulingContextWrapper>
      <ContainerNew>
        <HospitalCancelledScheduleSurgeryRequestsLayout />
      </ContainerNew>
    </SurgicalSchedulingContextWrapper>
  )
}

export default HospitalCancelledScheduledSurgeryRequests
